/**
 * Plays a simple, pleasant "tong" chime sound using the Web Audio API.
 * Used for audio feedback when the microphone is turned on or off.
 *
 * @param {boolean} isStarting - True if the mic is turning on, false if turning off.
 */
export const playMicToggleSound = (isStarting = true) => {
  try {
    const AudioContext = window.AudioContext || window.webkitAudioContext;
    if (!AudioContext) return;

    const ctx = new AudioContext();
    const osc = ctx.createOscillator();
    const gainNode = ctx.createGain();

    osc.connect(gainNode);
    gainNode.connect(ctx.destination);

    // Subtle "tong" using sine wave (like a marimba/xylophone bell)
    osc.type = "sine";
    
    // Slightly higher pitch for turning ON, lower for OFF
    osc.frequency.setValueAtTime(isStarting ? 523.25 : 440, ctx.currentTime); // C5 or A4

    // Volume envelope: quick attack, smooth fade out
    gainNode.gain.setValueAtTime(0, ctx.currentTime);
    gainNode.gain.linearRampToValueAtTime(0.15, ctx.currentTime + 0.02); // fade in 20ms
    gainNode.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.4); // fade out over 400ms

    osc.start(ctx.currentTime);
    osc.stop(ctx.currentTime + 0.5);
  } catch (e) {
    console.warn("AudioContext could not play mic toggle sound:", e);
  }
};
